export default "__VITE_ASSET__CxkV$g6___"